import { FieldArray } from 'react-final-form-arrays';
import { useCallback, useContext, useState } from 'react';

import { Button } from 'UIPackage/MainModule/components/Button';
import { IKnmErknmFormViolation } from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { ErknmViolationsSelectModal } from 'KnmErknmPackage/ErknmViolationsModule/components/ErknmViolationsSelectModal';
import { ViolationStatusesEnum } from 'APIPackage/KnmModule/enums/ViolationStatusesEnum';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';
import { Hint } from 'CorePackage/MainModule/components/Hint';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { AgreementsContext } from 'KnmErknmPackage/ErkmAgreementsModule/AgreementsContext';

import { ErknmAgreementsViolationItem } from './ErknmAgreementsViolationItem';

interface IErknmAgreementsViolationItemsProps {
  actViolations: IKnmErknmFormViolation[];
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  mId: string;
  name: string;
  watchOnly: boolean;
}

export const ErknmAgreementsViolationItems = ({
  actViolations,
  formRef,
  mId,
  name,
  watchOnly,
}: IErknmAgreementsViolationItemsProps) => {
  const { isKnm, isPm, isDecision } = useContext(AgreementsContext);
  const [isViolationSelectModalVisible, setIsViolationSelectModalVisible] = useState(false);
  const onOpenViolationSelectModal = useCallback(() => setIsViolationSelectModalVisible(true), []);
  const onCloseViolationSelectModal = useCallback(() => setIsViolationSelectModalVisible(false), []);

  const violationsFieldName = `${name}.violations`;
  const push = formRef?.current.mutators.push;
  const remove = formRef?.current.mutators.remove;

  // @ts-ignore
  const alreadyInListViolationIds = ((formRef?.current.getFieldState(violationsFieldName)?.value ||
    []) as IKnmErknmFormViolation[]).map(violation => violation.id);

  const violationsForAdding = actViolations.filter(
    actViolation =>
      (actViolation.status === ViolationStatusesEnum.NOT_FIXED ||
        actViolation.status === ViolationStatusesEnum.APPROVING) &&
      !alreadyInListViolationIds.includes(actViolation.id),
  );

  const handleAddViolations = useCallback((selectedViolations: IKnmErknmFormViolation[]) => {
    const newViolations = selectedViolations.map(selectedViolation => ({
      ...selectedViolation,
      isNew: true,
    }));

    push && newViolations.forEach(violation => push(violationsFieldName, violation));
  }, []);
  const getRemoveViolationHandler = useCallback(
    index => () => {
      remove && remove(violationsFieldName, index);
    },
    [],
  );

  return (
    <>
      <FieldBlock
        label={getTitleFieldWithRedStar({
          label: 'Нарушения',
          field: violationsFieldName,
          isPm,
          isKnm,
          isDecision,
        })}
        id={`${mId}.violations`}
        button={
          !watchOnly ? (
            <Button
              className="shared-btn-add"
              text="Добавить"
              type="button"
              variant="link"
              color="primary"
              onClick={onOpenViolationSelectModal}
            />
          ) : undefined
        }
      />
      <Hint text="Каждое нарушение должно быть добавлено отдельно" margin="bottom" />
      <FieldArray name={violationsFieldName}>
        {({ fields, meta }) => (
          <>
            {fields.map((violationFieldNameName, index) => {
              const violationValue: IKnmErknmFormViolation = fields.value[index];

              return (
                <ErknmAgreementsViolationItem
                  key={violationFieldNameName}
                  violation={violationValue}
                  fieldName={violationFieldNameName}
                  onRemove={getRemoveViolationHandler(index)}
                  formRef={formRef}
                  mId={`${mId}.violations[${index}]`}
                />
              );
            })}
            {typeof meta.error === 'string' && (
              <p className="shared-input-error shared-row__small-margin">{meta.error}</p>
            )}
          </>
        )}
      </FieldArray>
      <ErknmViolationsSelectModal
        violations={violationsForAdding}
        visible={isViolationSelectModalVisible}
        onClose={onCloseViolationSelectModal}
        onSubmit={handleAddViolations}
      />
    </>
  );
};
